export const AUTH_SESSION_TIMEBOX_DAYS = 30;

export function maskAccountIdentifier(email?: string | null, userId?: string): string {
  const normalized = email?.trim();
  if (normalized?.includes("@")) {
    const [local = "", domain = ""] = normalized.split("@");
    const visible = local.slice(0, Math.min(2, local.length));
    return `${visible}${local ? "…" : ""}@${domain}`;
  }
  if (userId) return `账号 ${userId.slice(0, 6)}…`;
  return "已登录账号";
}
